module.exports = __webpack_public_path__ + "media/images/person/med_setsuko_san-8bb1179198e4be7f55e58587cb2aced5.jpg";